import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { failedResponse, getBackendUrl, loaded, loading, error, LoadStateInfo, notStarted } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { ConversationMessage } from "./conversationSlice";
import { RootState } from "../../app/store";

export interface MessageSendRequest {
    conversationId: string;
    partyId: string;
    text: string;
}

export const performMessageSend = createAsyncThunk(
    "performMessageSend",
    async (param: MessageSendRequest, thunkAPI) => {
        console.debug("send message");

        const response = await fetch(`${getBackendUrl()}/api/conversation/message/${param.conversationId}/${param.partyId}`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Content-Type": "text/plain",
                "Authorization": `Bearer ${getToken()}`,
            },
            body: param.text,
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);

export interface MessageSendState {
    state: LoadStateInfo;
    request?: MessageSendRequest;
    message?: ConversationMessage;
}

const initialState: MessageSendState = {
    state: notStarted(),
};

export const messageSendSlice = createSlice({
    name: "messageSendMassive",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
            state.message = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(performMessageSend.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
                state.message = undefined;
            })
            .addCase(performMessageSend.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
                state.message = action.payload;
            })
            .addCase(performMessageSend.rejected, (state, action) => {
                state.state = error(action);
                state.message = undefined;
            });
    },
});

// export const { } = messageSendSlice.actions;

export const selectMessageSend = (state: RootState) => state.messageSend;

export default messageSendSlice.reducer;
